import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";

@Component({
  selector: 'app-percent-field',
  templateUrl: './percent-field.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PercentFieldComponent),
    }
  ]
})
export class PercentFieldComponent extends BaseControlValueAccessor implements OnInit {
  ifError: boolean = false;


  @Input()
  stepValue: number = 1;

  @Input()
  minValue: number = 0;

  @Input()
  maxValue: number = 100;

  @Input()
  minlength: number = 0;

  @Input()
  maxlength: number = 5;

  constructor() {
    super();
  }

  ngOnInit(): void {

  }

  override get data() {
    return this._data
  }

  override set data(val) {
    this._data = val;
    this.validate(val);
    this.onChange(val);
  }

  default(event) {
    if (event.keyCode == 101 || event.keyCode == 43 || event.keyCode == 45) {
      event.preventDefault();
    }
    // e=keyCode: 101
    //  +=keyCode43
    //   -=keyCode:45
  }

  onFocusOut(event) {
    this.data = this.roundoff_decimal(this.data)
  }

  override validate(val) {
    this.errors = [];
    // if (val < this.minValue) {
    //   this.errors.push(`Minimum value permitted is ${this.minValue}`);
    // }

    // if (val > this.maxValue) {
    //   this.errors.push(`Maximum value permitted is ${this.maxValue}`);
    // }
  }

}
